import { apiHelper } from '@/utils/requestHelpers';

export default {
  getAllShops() {
    return apiHelper.get('/restapi/v1/admin/shop-info');
  },
  getShopInfo(locationCode) {
    return apiHelper.get(`/restapi/v1/admin/shop-info/${locationCode}`);
  },
  /*
   * parameter is Array of shops, may be one shop or multiple shops when import csv
   */
  createShops(payload) {
    return apiHelper.post('/restapi/v1/admin/shop-info', payload);
  },
  editShop(locationCode, payload) {
    return apiHelper.put(`/restapi/v1/admin/shop-info/${locationCode}`, payload);
  },
  deleteShop(locationCode) {
    return apiHelper.delete(`/restapi/v1/admin/shop-info/${locationCode}`);
  },
  getShopCategories(category) {
    if (category) {
      return apiHelper.get('/restapi/v1/admin/shop-info/categories', { params: { category } });
    }
    return apiHelper.get('/restapi/v1/admin/shop-info/categories');
  }
};
